module.exports = __webpack_public_path__ + "img/shubl.167534e7.png";